<template>
  <div class="container">
    <div class="main-container">
      <div class="left-box">
        <div class="panel address-panel">
          <h2 class="title">
            <span>确认收货地址</span>
            <span class="btn-address" @click="add_address">使用新地址</span>
          </h2>
          <div class="address-list">
            <div
              class="address-item"
              :class="{ active: form_data.address_id === v.id }"
              v-for="(v, k) in address_list"
              :key="`a` + k"
              @click="change_address(v)"
            >
              <img
                v-if="form_data.address_id === v.id"
                src="../../assets/images/icon-location-active.png"
                class="location"
                alt=""
              />
              <img
                v-else
                src="../../assets/images/icon-location.png"
                class="location"
                alt=""
              />
              <div class="content1">
                <span>{{ v.province }}</span
                ><span>{{ v.city }}</span
                ><span>{{ v.zone }}</span>
              </div>
              <div class="content2">
                {{ v.address }}
              </div>
              <div class="contact">
                {{ v.contact_person }}{{ v.contact_mobile }}
              </div>
              <div class="btn-edit" @click.stop="edit_address(v.id)">编辑</div>
            </div>
          </div>
        </div>

        <popup
          :show.sync="is_popup_show"
          width="490px"
          height="520px"
          @on-close="close"
        >
          <h2>{{ form_data_address.id ? "编辑收货地址" : "添加收货地址" }}</h2>
          <div class="form">
            <div class="form-group">
              <div class="form-label">收货人：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入收货人"
                  v-model="form_data_address.contact_person"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">手机号：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入手机号"
                  maxlength="11"
                  v-model="form_data_address.contact_mobile"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">所在地区：</div>
              <div class="form-control">
                <Cascader
                  class="input1"
                  :data="region"
                  v-model="value"
                  placeholder="请选择省/市/区/街道"
                ></Cascader>
              </div>
            </div>

            <div class="form-group">
              <div class="form-label">详细地址：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"
                  v-model="form_data_address.address"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label"></div>
              <div class="form-control">
                <input
                  type="checkbox"
                  v-model="form_data_address.is_default"
                />是否默认地址
              </div>
            </div>
            <div class="btn-submit" @click="save">保存地址</div>
          </div>
        </popup>

        <!-- 客供面料提示 -->
        <popup
          :show.sync="show_custom_tips"
          width="471px"
          height="auto"
          @on-close="onCloseTips"
        >
          <div class="custom-tips-box">
            <div class="box-title">
              <div class="title-icon">i</div>
              <div class="title">温馨提示</div>
            </div>
            <div class="tips-content">客供面料，平台不支持快递到付，如需到付请勾选到付服务</div>
            <!-- 此处增加一个选项，用户可以选择是否同意到付服务,使用checkbox组件 -->
            <div class="checkbox">
              <Checkbox v-model="use_delivery_pay" />
              <!-- 点击文字也要让控制checkbox选中状态 -->
              <span @click="use_delivery_pay = !use_delivery_pay">我需要使用到付服务</span>
            </div>
            <div class="use-service">
              工厂收到该面料并确定快递费用后，平台客服将会联系您进行在线支付快该单递费用~
            </div>
            <div class="btn-box">
              <div class="cancel" @click="onCloseTips">取消</div>
              <div class="confirm" @click="onConfirmPayDelivery">确认</div>
            </div>
          </div>
        </popup>

        <div class="panel product-panel">
          <table border>
            <thead>
              <tr>
                <th>产品信息</th>
                <th>规格</th>
                <th>单价</th>
                <th>数量</th>
              </tr>
            </thead>
            <tbody>
              <template>
                <tr v-for="(v, k) in detail.mtms" :key="k">
                  <td>
                    <div class="info">
                      <img
                        :src="v.design_data.category.image"
                        alt=""
                        class="image"
                      />
                      <div class="name">
                        {{ v.design_data.category.style_no }}
                      </div>
                      <div class="category">
                        {{ v.design_data.category.product_category_name }}
                      </div>
                    </div>
                  </td>
                  <td>
                    {{ v.spec_info.join("；") }}
                  </td>
                  <td>
                    <template v-if="Number(v.price) > 0">¥{{ Number(v.price).toFixed(2) }}</template>
                    <template v-else>—</template>
                  </td>
                  <td>×{{ v.quantity }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="bulk-freight-tip" v-if="is_bulk_payment">温馨提示：本次报价金额不包含运费！</div>

        <div class="panel summary-panel">
           <h2 class="title">
            <span>订单备注</span>
          </h2>
          <textarea
            cols="30"
            rows="10"
            v-model="form_data.comment"
            placeholder="请输入你的备注，付款后商家可见，建议和商家协商一致"
          ></textarea>
        </div>
      </div>
      <div class="right-box">
        <div class="panel operation-panel">
          <h2 class="title">{{ is_bulk_order ? "大货报价单" : "样衣定制报价单" }}</h2>
          <template v-if="is_bulk_order">
            <div class="item">
              <div class="text">请确认订单情况并提交报价</div>
            </div>
          </template>
          <template v-else-if="is_bulk_payment">
            <div class="item">
              <div class="label">订单金额</div>
              <div class="text" style="font-size: 18px; color: #fa3d5a">￥{{ Number(detail.quotation_price || 0).toFixed(2) }}</div>
            </div>
          </template>
          <template v-else>
              <div class="item">
                <div class="label">订单号</div>
                <div class="text no-weight">{{ detail.order_no }}</div>
              </div>
              <div class="item">
                <div class="label">预计发货时间</div>
                <div class="text no-weight">{{ predict_delivery_date }}</div>
              </div>
              <div class="item" v-for="(vv, kk) in detail.cost_list" :key="kk">
              <div class="label">{{ vv.title }}</div>
              <div class="text">￥{{ vv.amount }}</div>
            </div>
          </template>
          <template v-if="!is_bulk_payment && !is_bulk_order">
              <div class="separator"></div>
              <div class="integral">
                <label class="checkbox-label">
                  <input type="checkbox" :checked="is_expedited" @click.stop="onSetExpedited"/>是否加急
                </label>
              </div>
          </template>
          <div class="separator"></div>
          <div class="integral" v-if="!is_bulk_order && setting && setting.c_coupon_deduct_coupon >0 && setting.max_c_coupon_deduct_ratio">
            <label class="checkbox-label">
              <input type="checkbox" :checked="useCCouponDeduct" @change="switchCCouponChange"/>消费券抵扣<span>(当前账号消费券{{userInfo.c_coupon || 0}})</span>
            </label>
            <div class="checkbox-value">¥{{ c_coupon_pay_money }}</div>
          </div>
          <div class="separator"></div>
          <div class="integral" v-if="!is_bulk_order && pointSetting.shoppingDeductPoint >0 && pointSetting.maxDeductRatio > 0">
              <label class="checkbox-label">
                <input type="checkbox" :checked="usePointDeduct" @change="switchPointChange"/>积分抵扣<span>(当前账号积分{{userInfo.point || 0}})</span>
              </label>
              <div class="checkbox-value">¥{{ point_pay_money }}</div>
          </div>
          <div class="separator"></div>

          <div class="item" v-if="!is_bulk_order">
            <div class="label">实付款</div>
            <div class="text" style="font-size: 18px; color: #fa3d5a">
              ￥{{ total_price }}
            </div>
          </div>

          <div class="pay-list" v-if="!is_bulk_order">
            <label
              class="pay-item"
              :class="{ 'pay-disabled': isPayDisabled(v) }"
              v-for="(v, k) in pay_list"
              :key="`pa` + k"
            >
              <input
                type="checkbox"
                :checked="v.checked"
                :disabled="isPayDisabled(v)"
                @change="change_payment(v)"
              />
              <img :src="v.icon" alt="" class="icon" />
              <div>
                {{ v.name
                }}<span v-if="v.type === 'balance'"
                  >(余额:¥{{ userInfo.available_balance }})</span
                >
              </div>
            </label>
          </div>
          
          <div class="btn-checkout" @click="checkout">{{ is_bulk_order ? "提交订单，获取报价" : "确认支付" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  AddressList,
  CalculateFreight,
  ChangeExpedited,
  CheckoutOrder,
  GetAddress,
  getSetting,
  OrderDetail,
  PayOrder,
  Profile,
  SaveAddress,
  UpdatePayOnDelivery,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import region from "@/utils/region.js";
import { checkMobile } from "@/utils/util";
import axios from "axios";
import { mapState } from "vuex";

const form_data_address = {
  id: 0,
  contact_person: "",
  contact_mobile: "",
  province: "",
  city: "",
  zone: "",
  address: "",
  is_default: 0,
};
export default {
  name: "OrderCheckout",
  components: {
    Popup,
  },
  data() {
    return {
      value: [],
      region: region,
      form_data_address: { ...form_data_address },
      is_popup_show: false,
      is_click: false,
      address_list: [],
      form_data: {
        address_id: 0,
        uuid: "",
        date_required: "",
        comment: "",
        is_tech_real: false,
        is_try_pattern: false,
      },
      pay_type: "wechat",
      detail: {
        spec_info: [],
        cost_list: [],
        cost: [],
      },
      design: {},
      pay_list: [
        {
          name: "微信支付",
          icon: require("../../assets/images/icon_weixin@2x.png"),
          type: "wechat",
          checked: true,
        },
        {
          name: '支付宝支付',
          icon: require('../../assets/images/icon_zhifubao@2x.png'),
          type: 'alipay',
          checked: false,
        },
        {
          name: `余额支付`,
          icon: require("../../assets/images/icon-balance-pay.png"),
          type: "balance",
          checked: false,
        },
      ],
      is_expedited:false,
      useCCouponDeduct:false,
      usePointDeduct:false,
      pointSetting:{
        shoppingDeductPoint: 0,
        maxDeductPoint: 0,
      },
      show_custom_tips: false,
      use_delivery_pay: false,
      confirm_delivery: false,
    };
  },
  computed: {
    ...mapState({
      setting: (state) => state.setting,
      userInfo: (state) => state.userInfo
    }),
    payable_amount() {
      if (this.detail.is_deposit == 1 && Number(this.detail.deposit_price) > 0) {
        return Number(this.detail.deposit_price);
      }
      return Number(this.detail.total_price || 0);
    },
    c_coupon_pay_money() {
      let c_coupon_pay_money = 0
      if (this.useCCouponDeduct && this.setting) {
        let maxDeductPrice = this.setting.max_c_coupon_deduct_ratio / 100 * (this.payable_amount);
        if ((this.userInfo.c_coupon * this.setting.c_coupon_deduct_coupon) >= maxDeductPrice) {
          c_coupon_pay_money = maxDeductPrice;
        } else {
          c_coupon_pay_money = Number(this.userInfo.c_coupon * this.setting.c_coupon_deduct_coupon);
        }
        return c_coupon_pay_money.toFixed(2)
      }
      return c_coupon_pay_money
    },
    point_pay_money() {
      if (this.usePointDeduct) {
        var maxDeductPrice = this.pointSetting.maxDeductRatio / 100 * (this.payable_amount - this.c_coupon_pay_money);
        if ((this.userInfo.point * this.pointSetting.shoppingDeductPoint) > maxDeductPrice) {
          var point_pay_money = maxDeductPrice;
        } else {
          var point_pay_money = this.userInfo.point * this.pointSetting.shoppingDeductPoint;
        }
        return point_pay_money.toFixed(2)
      }
      return 0
    },
    virtual_pay_money() {
      return Number(this.point_pay_money) + Number(this.c_coupon_pay_money)
    },
    total_price() {
      return Number(this.payable_amount - this.c_coupon_pay_money - this.point_pay_money).toFixed(2);
    },
    // 最终应付金额（用于判断余额是否足够支付），供支付勾选策略使用
    finalPayPrice() {
      return Number(this.total_price || 0);
    },
    is_bulk_order() {
      return this.detail.from_scene === 'design' && this.detail.status == -1;
    },
    // 大货订单已报价、进入支付定金/尾款阶段（非下单预览）
    is_bulk_payment() {
      return this.detail.from_scene === 'design' && Number(this.detail.status) != -1;
    },
    predict_delivery_date() {
      if (!this.detail.mtms || this.detail.mtms.length === 0) {
        return '-';
      }
      const dates = this.detail.mtms
        .map(m => m.predict_delivery_date)
        .filter(d => d);
      if (dates.length === 0) {
        return '-';
      }
      return dates.sort()[0];
    },
  },
  watch: {
    // 应付金额/余额变化时，纠正已选支付方式，避免出现非法组合
    total_price() {
      this.normalizePayType();
    },
    "userInfo.available_balance"() {
      this.normalizePayType();
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      console.log("aaa");
      vm.$emit("showFooter", false);
    });
  },

  beforeRouteLeave(to, from, next) {
    this.$emit("showFooter", true);
    next();
  },
  async mounted() {
    await this.$store.dispatch("getSetting");
    if (this.setting && this.setting.offlinePay) {
      this.pay_list.push({
        name: "线下支付",
        icon: require("../../assets/images/icon-pay-offline.png"),
        type: "offline",
        checked: false,
      });
    }
    this.getPointSetting();
    const {uuid} = this.$route.query;
    this.form_data.uuid = uuid;
    if (!uuid) {
      this.$router.back();
      return;
    }

    let data = await this.onGetDetail();
    this.form_data.is_tech_real = Boolean(data.is_tech_real);
    axios.all([this.getProfile(), this.getAddressList()]).then(
      axios.spread(() => {
        console.log('data--->',data);
        let default_address = this.address_list.find((elem, key) => {
          return elem.is_default === 1;
        });

        const {province, city, zone, address, contact_mobile, contact_person} = data;
        let current;
        if(province && city && zone && address && contact_mobile && contact_person){
          current = this.address_list.find((item)=>{
            return item.province === province && item.city === city && item.zone === zone && item.address === address && item.contact_mobile === contact_mobile && item.contact_person === contact_person;
          })
        }
        this.form_data.address_id = default_address ? default_address.id : (this.address_list[0]?.id || 0);
        if(current){
          this.form_data.address_id = current.id;
        }
        // 页面加载后根据默认地址计算一次运费
        if (this.form_data.address_id) {
          this.reCalcFreight(this.form_data.address_id);
        }
      })
    );
  },
  methods: {
    async getPointSetting() {
      let { data } = await getSetting({ code: "user", key: "pointSetting" });
      if (data) {
        this.pointSetting = data;
      }
    },
    switchPointChange(e) {
      this.usePointDeduct = !this.usePointDeduct
    },
    switchCCouponChange(e) {
      this.useCCouponDeduct = !this.useCCouponDeduct
    },
    onSetExpedited(){
      this.is_expedited = !this.is_expedited;
      this.onChangeExpedited();
    },
    onGetDetail() {
      return OrderDetail({
        uuid: this.$route.query.uuid,
      }).then((response) => {
        this.detail = response.data;
        this.design = this.detail.design;
        this.form_data.is_try_pattern = this.detail.is_try_pattern;
        this.is_expedited = this.detail.urgent;
        // 客供面料到付服务：回填已落库的选择，避免从 Center 确认进入 Checkout 后二次弹窗未重勾导致 is_pay_on_delivery 被覆盖为 0
        this.use_delivery_pay = !!Number(this.detail.is_pay_on_delivery);
        // 若已在 Center 端确认选用到付(is_pay_on_delivery=1)，视为已确认，跳过 Checkout 二次弹窗
        if (this.detail.is_pay_on_delivery) {
          this.confirm_delivery = true;
        }
        return response.data;
      });
    },
    async onChangeExpedited() {
      try {
        const param = {};
        param.is_expedited = this.is_expedited;
        param.uuid = this.detail.uuid;
        console.log("expedited_param", param);
        await ChangeExpedited(param);
      } catch (e) {
        console.log("err-expedited", e);
      } finally {
        await this.onGetDetail();
      }
    },
    close() {
      this.form_data_address = { ...form_data_address };
      this.value = [];
    },
    save() {
      this.form_data_address.province = this.value[0];
      this.form_data_address.city = this.value[1];
      this.form_data_address.zone = this.value[2];
      if(!this.form_data_address.contact_person){
        this.$layer.msg('请输入姓名');
        return;
      }
      if(!this.form_data_address.contact_mobile){
        this.$layer.msg('请输入手机号');
        return;
      }
      if (!checkMobile(this.form_data_address.contact_mobile.trim())) {
        this.$layer.msg('请输入正确的手机号');
        return;
      }
      if(!this.form_data_address.province){
        this.$layer.msg('请选择省份');
        return;
      }
      if(!this.form_data_address.city){
        this.$layer.msg('请选择城市');
        return;
      }
      if(!this.form_data_address.zone){
        this.$layer.msg('请选择区县');
        return;
      }
      if(!this.form_data_address.address){
        this.$layer.msg('请输入详细地址');
        return;
      }
      SaveAddress(this.form_data_address)
        .then(async (response) => {
          this.$layer.msg(`保存成功`);
          this.form_data_address = { ...form_data_address };
          this.value = [];
          this.is_popup_show = false;
          await this.getAddressList();
          // 保持原地址选择；仅当未选择或已选地址已不存在时，才回退到默认地址
          const selectedId = this.form_data.address_id;
          const selectedStillExists = this.address_list.some(
            (item) => item.id === selectedId
          );
          if (!selectedId || !selectedStillExists) {
            const default_address = this.address_list.find(
              (item) => item.is_default === 1
            );
            this.form_data.address_id = default_address
              ? default_address.id
              : this.address_list[0]?.id || 0;
          }
          // 新增/编辑地址后重新计算运费
          if (this.form_data.address_id) {
            await this.reCalcFreight(this.form_data.address_id);
          }
        })
    },
    add_address() {
      if(this.address_list.length < 1){
        this.form_data_address.is_default = 1;
      }
      this.is_popup_show = true;
      
    },
    edit_address(id) {
      GetAddress({ id }).then((response) => {
        this.form_data_address = response.data;
        this.value = [
          this.form_data_address.province,
          this.form_data_address.city,
          this.form_data_address.zone,
        ];
        this.is_popup_show = true;
      });
    },
    // 余额支付是否为禁用态：余额为0时禁选并置灰
    isPayDisabled(item) {
      if (item.type !== "balance") return false;
      return Number(this.userInfo.available_balance || 0) === 0;
    },
    // 当前余额与应付金额的关系，决定支付方式的可选组合（与小程序一致）
    // 1) 余额足够支付 finalPayPrice：余额/微信/支付宝三者互斥，只能选其一
    // 2) 余额为0：余额禁选（置灰）
    // 3) 余额不为0且不足：余额可与微信/支付宝组合（微信/支付宝互斥）
    change_payment(item) {
      // 线下支付为整单独立支付方式，与其它互斥
      if (item.type === "offline") {
        const next = !item.checked;
        this.pay_list.forEach((i) => {
          i.checked = false;
        });
        item.checked = next;
        return;
      }
      const balance = Number(this.userInfo.available_balance || 0);
      const finalPayPrice = Number(this.finalPayPrice || 0);
      const balanceZero = balance === 0;
      const balanceEnough = balance >= finalPayPrice; // 含应付为0视为足够
      // 余额为0：余额禁选
      if (item.type === "balance" && balanceZero) return;
      // 已选中再次点击 = 取消
      if (item.checked) {
        item.checked = false;
        return;
      }
      if (item.type === "balance") {
        // 余额足够时与微信/支付宝互斥：取消其它已选
        if (balanceEnough) {
          this.pay_list.forEach((i) => {
            if (i.type !== "balance") i.checked = false;
          });
        }
        // 余额不足时可与微信/支付宝组合（微信/支付宝互斥）
        item.checked = true;
      } else if (item.type === "wechat" || item.type === "alipay") {
        this.pay_list.forEach((i) => {
          // 微信/支付宝互斥
          if ((i.type === "wechat" || i.type === "alipay") && i.type !== item.type)
            i.checked = false;
          // 余额足够时与余额互斥
          if (balanceEnough && i.type === "balance") i.checked = false;
          // 与线下支付互斥
          if (i.type === "offline") i.checked = false;
        });
        item.checked = true;
      }
    },
    // finalPayPrice 动态变化时，实时纠正已选支付方式，避免出现非法组合：
    // - 余额为0：确保余额未选中
    // - 余额足够：三者只能保留其一（优先级：余额 > 微信 > 支付宝）
    normalizePayType() {
      const balance = Number(this.userInfo.available_balance || 0);
      const balanceZero = balance === 0;
      const balanceEnough = balance >= Number(this.finalPayPrice || 0);
      if (balanceZero) {
        const b = this.pay_list.find((i) => i.type === "balance");
        if (b) b.checked = false;
      }
      if (balanceEnough) {
        const checked = this.pay_list.filter((i) => i.checked);
        if (checked.length > 1) {
          const keep =
            this.pay_list.find((i) => i.checked && i.type === "balance") ||
            this.pay_list.find((i) => i.checked && i.type === "wechat") ||
            this.pay_list.find((i) => i.checked && i.type === "alipay");
          this.pay_list.forEach((i) => {
            if (i !== keep) i.checked = false;
          });
        }
      }
    },
    onCloseTips() {
      this.show_custom_tips = false;
      this.use_delivery_pay = false;
      this.confirm_delivery = false;
    },
    async onConfirmPayDelivery() {
      const uuid = this.form_data.uuid;
      const { use_delivery_pay } = this;
      try {
        const { code, msg } = await UpdatePayOnDelivery({
          uuid,
          is_pay_on_delivery: use_delivery_pay ? 1 : 0,
        });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.show_custom_tips = false;
        this.confirm_delivery = true;
        this.checkout();
      } catch (error) {
        console.error("Update pay on delivery failed:", error);
      }
    },
    async checkout() {
      if (this.is_click) {
        return;
      }
      if (this.form_data.address_id === 0) {
        this.$layer.msg(`请选择收货地址`);
        return;
      }

      // 客供面料提示：需寄送面辅料（客供面料）的订单，先确认是否使用到付服务
      if (this.detail.is_need_send_back && !this.confirm_delivery) {
        this.show_custom_tips = true;
        return;
      }

      // 大货订单直接提交，不进入支付流程
      if (this.is_bulk_order) {
        this.is_click = true;
        CheckoutOrder({ ...this.form_data })
          .then(() => {
            this.$layer.msg(`提交成功，等待平台报价`);
            setTimeout(() => {
              this.$router.replace({
                name: "OrderDetail",
                query: { uuid: this.form_data.uuid },
              });
            }, 1500);
          })
          .catch((e) => {
            this.$layer.msg(e.msg);
          })
          .finally(() => {
            this.is_click = false;
          });
        return;
      }

      // 接口参数预处理 Start
      let payTypes = this.pay_list.filter((i) => {
        return i.checked
      }).map((i) => {
        return i.type
      })
      if (payTypes.length == 0) {
        return this.$layer.msg('请选择支付方式')
      }
      let pay_param = {
        use_balance: false,
        use_wechat: false,
        use_alipay: false,
        use_offline:false,
        usePointDeduct:this.usePointDeduct,
        useCCouponDeduct:this.useCCouponDeduct,
      }
      if (payTypes.indexOf('balance') >= 0) {
        pay_param.use_balance = true
      }
      if (payTypes.indexOf('wechat') >= 0) {
        pay_param.use_wechat = true
      }
      if (payTypes.indexOf('alipay') >= 0) {
        pay_param.use_alipay = true
      }
      if (payTypes.indexOf('offline') >= 0) {
        pay_param.use_offline = true
      }
      // 积分、消费券等都属于虚拟财产支付
      let is_virtual_pay = this.usePointDeduct || this.useCCouponDeduct
      // 后续增加支付宝等，都属于三方在线支付
      let is_online_pay = pay_param.use_wechat || pay_param.use_alipay
      // 接口参数预处理 End

      this.is_click = true;
      CheckoutOrder({...this.form_data, pay_param})
        .then(({data}) => {
          console.log('res-data',data);
          // 虚拟财产支付足够订单金额
          if(this.virtual_pay_money >= this.payable_amount) {
            this.payBalance()
            return;
          }
          //使用余额且余额足够支付订单剩余金额
          if(pay_param.use_balance && Number(this.userInfo.available_balance) >= Number(this.payable_amount - this.virtual_pay_money)) {
            this.payBalance()
            return;
          }
          //>只有余额支付操作
          if(pay_param.use_balance && !is_online_pay) {
            this.payBalance()
            return;
          }

          //
          var pay_type = ''
          if (pay_param.use_wechat) {
            pay_type = 'wechat'
          }
          if (pay_param.use_alipay) {
            pay_type = 'alipay'
          }
          if (pay_param.use_offline) {
            pay_type = 'offline'
          }
          this.$layer.msg(`订单已确认，跳转支付中...`);
          setTimeout(() => {
            this.$router.replace({
              name: "CashDesk",
              query: { uuid: this.form_data.uuid, pay_type },
            });
          }, 1500);
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        })
        .finally(() => {
          this.is_click = false;
        });
    },

    payBalance() {
      const param = {};
      param.uuid = this.form_data.uuid;
      param.pay_type = 'balance';
      param.usePointDeduct = this.usePointDeduct
      param.useCCouponDeduct = this.useCCouponDeduct
      this.$Spin.show();
      PayOrder(param)
        .then((res) => {
          console.log("res-pay", res);
          this.$layer.msg("支付成功");
          this.$router.replace({
            name: "PayResult",
            query: { uuid: param.uuid },
          });
        })
        .catch((e) => {
          console.log("err-pay", e);
          this.$layer.msg(e.msg);
        })
        .finally(() => {
          this.$Spin.hide();
        });
    },
    go2address() {
      this.$router.push({ name: "Address" });
    },
    async change_address(v) {
      this.form_data.address_id = v.id;
      // 地址发生变动，调用运费计算接口并刷新订单详情
      await this.reCalcFreight(v.id);
    },
    async reCalcFreight(address_id) {
      try {
        await CalculateFreight({
          uuid: this.detail.uuid || this.form_data.uuid,
          address_id,
        });
      } catch (e) {
        console.log("err-calculate-freight", e);
      } finally {
        // 获取最新 detail.cost_list
        await this.onGetDetail();
      }
    },
    async getProfile() {
      return Profile().then((response) => {
        this.$store.commit("setUserInfo", this.$_.cloneDeep(response.data));
        return response;
      });
    },
    async getAddressList() {
      return AddressList().then((response) => {
        this.address_list = response.data;
        return response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1279px;
  max-width: 1920px;
  background: #f6f7fa;
  .main-container {
    width: 100%;
    max-width: 1516px;
    display: flex;
    justify-content: center;
    column-gap: 16px;
    .left-box {
      //   width: 100%;
      //   max-width: 1140px;
      flex: 3;
      min-width: 700px;
      display: flex;
      flex-direction: column;
      .panel {
        margin: 20px 0;
        padding: 30px 20px;
        background: white;
        border-radius: 10px;
        &.address-panel {
          max-width: 1140px;
          .title {
            display: flex;
            justify-content: space-between;
            color: #333333;
            font-size: 18px;
            font-weight: bold;
            .btn-address {
              color: #fa3d5a;
              font-size: 12px;
              font-weight: normal;
              cursor: pointer;
              margin: 0 10px;
            }
          }
          .address-list {
            display: flex;
            flex-wrap: wrap;
            .address-item {
              position: relative;
              margin: 10px 5px;
              width: 265px;
              height: 100px;
              padding: 10px 10px 10px 45px;
              color: #191a1c;
              border: 1px solid #e3e3e3;
              border-radius: 6px;
              cursor: pointer;
              .location {
                position: absolute;
                top: 16px;
                left: 16px;
                width: 20px;
                height: 24px;
              }
              .content1 {
                width: 200px;
                font-size: 12px;
                margin: 5px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                span {
                  margin: 0 3px;
                }
              }
              .content2 {
                width: 200px;
                font-size: 13px;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .contact {
                width: 200px;
                margin-top: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .btn-edit {
                position: absolute;
                right: 10px;
                bottom: 5px;
                font-size: 12px;
              }
              &.active {
                border: 1px solid #fa3d5a;
              }
            }
          }
        }

        &.product-panel {
          max-width: 1140px;
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 14px;
            table-layout: fixed;
            border: 1px solid #e5e5e5;
            thead {
              background: #f6f7fa;
              line-height: 52px;
              color: #575859;
              font-size: 14px;
              text-align: center;
            }
            th,
            td {
              border: 1px solid #e5e5e5;
              text-align: center;
              width: 190px;
              &:first-child {
                width: auto;
                min-width: 300px;
                max-width: 480px;
              }
            }
            tbody {
              tr {
                td {
                  .info {
                    position: relative;
                    width: 480px;
                    height: 110px;
                    // border-right: 1px solid #e3e3e3;
                    .image {
                      position: absolute;
                      top: 20px;
                      left: 20px;
                      width: 68px;
                      height: 68px;
                      object-fit: cover;
                    }
                    .name {
                      position: absolute;
                      top: 34px;
                      left: 150px;
                      color: #191a1c;
                      font-size: 14px;
                      font-weight: 500;
                    }
                    .category {
                      position: absolute;
                      top: 66px;
                      left: 150px;
                    }
                  }
                }
              }
            }
          }
          .th {
            display: flex;
            flex-wrap: nowrap;
            line-height: 52px;
            text-align: center;
            background: #f6f7fa;
            border-radius: 5px 5px 0px 0px;
            border: 1px solid #e3e3e3;
            color: #575859;
            font-size: 14px;
            .info {
              width: 480px;
            }
            .size {
              width: 190px;
            }
            .quantity {
              width: 190px;
            }
            .price {
              width: 190px;
            }
          }
          .td {
            display: flex;
            flex-wrap: nowrap;
            text-align: center;
            border: 1px solid #e3e3e3;
            .info {
              position: relative;
              width: 480px;
              height: 110px;
              border-right: 1px solid #e3e3e3;
              .image {
                position: absolute;
                top: 20px;
                left: 20px;
                width: 68px;
                height: 68px;
                object-fit: cover;
              }
              .name {
                position: absolute;
                top: 34px;
                left: 150px;
                color: #191a1c;
                font-size: 14px;
                font-weight: 500;
              }
              .category {
                position: absolute;
                top: 66px;
                left: 150px;
              }
            }
            .size {
              padding: 0 5px;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              align-content: center;
              justify-content: center;
              width: 190px;
              height: 110px;
              border-right: 1px solid #e3e3e3;
            }
            .quantity {
              width: 190px;
              height: 110px;
              line-height: 110px;
              border-right: 1px solid #e3e3e3;
            }
            .price {
              width: 190px;
              height: 110px;
              line-height: 110px;
              border-right: 1px solid #e3e3e3;
              font-weight: bold;
              font-size: 14px;
            }
          }
        }

        &.summary-panel {
          max-width: 1140px;
          .title {
            display: flex;
            justify-content: space-between;
            color: #333333;
            font-size: 18px;
            font-weight: bold;
          }
          textarea {
            width: 100%;
            height: 110px;
            margin-top: 14px;
            padding: 12px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #E3E3E3;
          }
        }
      }
    }
    .right-box {
      //   width: 360px;
      flex: 1;
      min-width: 100px;
      max-width: 360px;
      .panel {
        margin: 20px 0;
        padding: 30px 20px;
        background: white;
        border-radius: 10px;
        &.operation-panel {
          width: 100%;
          .item {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-between;
            margin: 8px 0;
            height: 22px;
            font-size: 14px;
            .label {
              width: 100px;
              color: #666;
            }
            .text {
              font-weight: bold;
              color: #333333;
            }
            .no-weight {
              color: #666;
              font-weight: normal;  
            }
          }
          .separator {
              height: 1px;
              border: 0.5px dashed #E3E3E3;
          }
          .integral {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #333;
            .checkbox-label {
              color: #1f1f1f;
              font-size: 14px;
              line-height: 45px;
              input {
                margin-right: 4px;
              }
              span {
                color: #666666;
                font-size: 12px;
                line-height: 45px;  
              }
            }
            .checkbox-value {
              color: #1f1f1f;
              font-size: 14px;
              font-weight: bold;
            }
          }
          .pay-list {
            padding: 25px;
            background: #f3f6f8;
            border-radius: 10px;
            .pay-item {
              display: flex;
              flex-wrap: nowrap;
              align-items: center;
              margin: 8px 0;
              color: #11192d;
              font-size: 14px;
              input {
                margin-right: 10px;
              }
              .icon {
                width: 20px;
                height: 20px;
              }
              div {
                margin-left: 10px;
              }
            }
            .pay-disabled {
              opacity: 0.45;
              cursor: not-allowed;
            }
          }

          .expedited {
            margin-top: 20px;
            font-weight: bold;
            font-size: 14px;
          }

          .btn-checkout {
            cursor: pointer;
            //   position: absolute;
            // width: 320px;
            //   bottom: 40px;
            width: 100%;
            margin-top: 50px;
            height: 42px;
            line-height: 42px;
            color: white;
            background: #fa3d5a;
            text-align: center;
            font-size: 14px;
            border-radius: 10px;
          }
        }
      }
    }
  }
}

.bulk-freight-tip {
  max-width: 1140px;
  margin: 10px 0;
  color: #fa3d5a;
  font-size: 14px;
}

::v-deep .popup-modal {
  display:flex;
  flex-direction:column;
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    flex:1;
    .form-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      width:100%;
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
        flex-shrink:0;
      }
      .form-control {
        position: relative;
        flex:1;
        .input {
          width: 100%;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly] {
            border: none;
          }
        }
      }
    }

    .btn-submit {
      margin: 40px 0 0 40px;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
  .custom-tips-box{
    width:100%;
    background:#fff;
    border-radius:10px;
    padding:26px 24px;
    position:relative;
    user-select:none;
    .box-title{
      display:flex;
      column-gap:10px;
      align-items:center;
      justify-content:center;
      .title-icon{
        width:20px;
        height:20px;
        background:#0d99ff;
        border-radius:50%;
        color:#fff;
        text-align:center;
        line-height:20px;
      }
      .title{
        color:#0f1115;
        font-size:18px;
        font-weight:bold;
      }
    }
    .tips-content{
      font-size:16px;
      color:#333;
      margin-top:20px;
    }
    .checkbox{
      display:flex;
      align-items:center;
      column-gap:8px;
      cursor:pointer;
      span{
        color:#333;
        font-size:14px;
      }
    }
    .use-service{
      width:100%;
      background: #FFEFF0;
      border-radius: 8px 8px 8px 8px;
      padding:12px;
      color:#333;
      font-size:14px;
      margin-top:13px;
    }
    .btn-box{
      width:100%;
      display:flex;
      align-items:center;
      justify-content:center;
      column-gap:14px;
      margin-top:32px;
      .cancel{
        width: 166px;
        height: 44px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E3E3E3;
        cursor:pointer;
        text-align:center;
        line-height:44px;
        font-size:16px;
        color:#666;
      }
      .confirm{
        width: 166px;
        height: 44px;
        background: #FF5967;
        border-radius: 4px 4px 4px 4px;
        color:#fff;
        cursor:pointer;
        text-align:center;
        line-height:44px;
        font-size:16px;
      }
    }
  }
}

::v-deep .ivu-input {
  width: 100%;
  height: 48px;
  line-height: 48px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 0 10px;
  outline: none;
}
</style>
